import { isArray } from "lodash";
import { useState, useEffect } from "react";

export interface Location {
  latitude: number | string;
  longitude: number | string;
  [key: string]: unknown;
}

interface GeoError {
  code: number;
  message: string;
}

export function vectorDistance(dx: number, dy: number) {
  return Math.sqrt(dx * dx + dy * dy);
}

export function locationDistance(location1: Location, location2: Location) {
  const dx = +location1.latitude - +location2.latitude,
    dy = +location1.longitude - +location2.longitude;
  return vectorDistance(dx, dy);
}

export function closestLocation<TData>(
  targetLocation: Location,
  locationData: TData[],
) {
  if (!locationData) return [];
  const closeLocation =
    isArray(locationData) &&
    [...locationData]?.sort((a, b) => {
      const aDistance = locationDistance(targetLocation, a as Location),
        bDistance = locationDistance(targetLocation, b as Location);
      return aDistance - bDistance;
    });

  return closeLocation;
}
function useClosestLocation<T>(data: T[]) {
  const [closestLocations, setClosestLocations] = useState(data);
  const [geoError, setError] = useState<null | GeoError>(null);
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        };

        const targetLocation = {
          latitude: userLocation.lat,
          longitude: userLocation.lon,
        };

        const getClosestLocation = closestLocation<T>(targetLocation, data);

        setClosestLocations(getClosestLocation as T[]);
      },
      (error: GeoError) => {
        setError(error);
      },
    );
  }, [data]);
  return { closestLocations, error: geoError };
}

export default useClosestLocation;
